export default __webpack_public_path__ + "static/media/centre-icon.71b7d514.png";